import React from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';

import { ReactComponent as DetailsEmptyStateIllustration } from '../../../../assets/rebranding/institucional/seguranca.svg';
import { PROPOSAL_TIPS } from '../constants';
import { EmptyDetailsWrapper } from './style';

export function EmptyDetails(): JSX.Element {
  return (
    <EmptyDetailsWrapper>
      <DetailsEmptyStateIllustration />
      <Title size="overline">icarros e você, juntos contra golpes</Title>
      <Title>confira dicas para se proteger e vender seu veículo de forma segura</Title>
      <List>
        {PROPOSAL_TIPS.map(({ icon, title, description }) => (
          <ListItem
            key={title}
            avatarIcon={icon}
            avatarVariant="icon"
            label={title}
            subLabel={description}
          />
        ))}
      </List>
    </EmptyDetailsWrapper>
  );
}
